module.exports = __webpack_public_path__ + "media/img/Landing_Page/Scholarships2u-Home-Banner-01-d85567585a8fd7b75e02699e37a16342.jpg";